import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/culture/banner.png';
import _imports_1 from '@/assets/culture/icon_core1.png';
import _imports_2 from '@/assets/culture/icon-more.png';
import _imports_3 from '@/assets/culture/icon_core2.png';
import _imports_4 from '@/assets/culture/icon_core3.png';
import _imports_5 from '@/assets/culture/icon_core4.png';
import _imports_6 from '@/assets/culture/core1.png';
import _imports_7 from '@/assets/culture/core2.png';
import _imports_8 from '@/assets/culture/core3.png';
import _imports_9 from '@/assets/culture/core4.png';
import _imports_10 from '@/assets/culture/worth1.png';
import _imports_11 from '@/assets/culture/worth2.png';
import _imports_12 from '@/assets/culture/worth3.png';
import _imports_13 from '@/assets/culture/worth4.png';
const _hoisted_1 = {
  class: "culture"
};
const _hoisted_2 = {
  class: "core content pb-120"
};
const _hoisted_3 = {
  class: "module"
};
const _hoisted_4 = {
  class: "consulting-container"
};
const _hoisted_5 = {
  class: "consulting-nav"
};
const _hoisted_6 = {
  class: "consulting-content-wrapper"
};
const _hoisted_7 = {
  src: _imports_6,
  class: "consulting-content-bg-img",
  "data-service": "training"
};
const _hoisted_8 = {
  src: _imports_7,
  class: "consulting-content-bg-img",
  "data-service": "insight"
};
const _hoisted_9 = {
  src: _imports_8,
  class: "consulting-content-bg-img",
  "data-service": "escort"
};
const _hoisted_10 = {
  src: _imports_9,
  class: "consulting-content-bg-img",
  "data-service": "connect"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const consultingId = ref(0);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "module_title"
      }, "核心价值观", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: _normalizeClass([consultingId.value === 0 ? 'active' : '', "consulting-tab"]),
        "data-service": "training",
        onClick: _cache[0] || (_cache[0] = $event => consultingId.value = 0)
      }, _cache[4] || (_cache[4] = [_createElementVNode("img", {
        src: _imports_1,
        class: "tab-icon"
      }, null, -1), _createElementVNode("span", {
        class: "tab-text"
      }, "专业立身", -1), _createElementVNode("img", {
        src: _imports_2,
        class: "icon-more"
      }, null, -1)]), 2), _createElementVNode("div", {
        class: _normalizeClass([consultingId.value === 1 ? 'active' : '', "consulting-tab"]),
        "data-service": "insight",
        onClick: _cache[1] || (_cache[1] = $event => consultingId.value = 1)
      }, _cache[5] || (_cache[5] = [_createElementVNode("img", {
        src: _imports_3,
        class: "tab-icon"
      }, null, -1), _createElementVNode("span", {
        class: "tab-text"
      }, "创新驱动", -1), _createElementVNode("img", {
        src: _imports_2,
        class: "icon-more"
      }, null, -1)]), 2), _createElementVNode("div", {
        class: _normalizeClass([consultingId.value === 2 ? 'active' : '', "consulting-tab"]),
        "data-service": "escort",
        onClick: _cache[2] || (_cache[2] = $event => consultingId.value = 2)
      }, _cache[6] || (_cache[6] = [_createElementVNode("img", {
        src: _imports_4,
        class: "tab-icon"
      }, null, -1), _createElementVNode("span", {
        class: "tab-text"
      }, "责任担当", -1), _createElementVNode("img", {
        src: _imports_2,
        class: "icon-more"
      }, null, -1)]), 2), _createElementVNode("div", {
        class: _normalizeClass([consultingId.value === 3 ? 'active' : '', "consulting-tab"]),
        "data-service": "connect",
        onClick: _cache[3] || (_cache[3] = $event => consultingId.value = 3)
      }, _cache[7] || (_cache[7] = [_createElementVNode("img", {
        src: _imports_5,
        class: "tab-icon"
      }, null, -1), _createElementVNode("span", {
        class: "tab-text"
      }, "共赢生态", -1), _createElementVNode("img", {
        src: _imports_2,
        class: "icon-more"
      }, null, -1)]), 2)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_vShow, consultingId.value === 0]]), _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [[_vShow, consultingId.value === 1]]), _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_vShow, consultingId.value === 2]]), _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [[_vShow, consultingId.value === 3]])])])])]), _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"worth content pb-160\" data-v-f6bcf278><div class=\"module\" data-v-f6bcf278><div class=\"module_title\" data-v-f6bcf278>价值观践行体系</div><div class=\"worth_imgs\" data-v-f6bcf278><img src=\"" + _imports_10 + "\" alt=\"\" data-v-f6bcf278><img src=\"" + _imports_11 + "\" alt=\"\" data-v-f6bcf278><img src=\"" + _imports_12 + "\" alt=\"\" data-v-f6bcf278><img src=\"" + _imports_13 + "\" alt=\"\" data-v-f6bcf278></div></div></div>", 1))]);
    };
  }
});